import "./single-gallery.scss";
import "../../../js/core";

let galleryLoadMore = $('#gallery_load_more');
let sectionGallery = $('.section-gallery');
let currentPage = galleryLoadMore.data('current-page');
let clickSearch = 0;
galleryLoadMore.on('click', function () {
    $(this).addClass('is-loading loading-start').attr("disabled", true);

    let ajaxUrl = `${location.protocol}//${location.hostname}${location.port ? ':' + location.port : ''}/wp-admin/admin-ajax.php`;
    let galleryPosts = $(this).data('gallery-posts');
    let galleryUrl = $(this).data('gallery-url');
    let postPerLoad = $(this).data('post-per-page');
    let search = $('.result-search span').text();
    let maxPages = $(this).data('max-pages');
    let termsArr = sectionGallery.data('terms-arr');
    let postIdsArr = galleryLoadMore.data('post-ids-arr');

    let data = {
        'action': 'gallery_ajax_search',
        'query': galleryPosts,
        'paged': currentPage,
        'gallery_url': galleryUrl,
        'post-per-load': postPerLoad,
        'gallery-search': search,
        'terms_arr': termsArr,
        'post_ids_arr': postIdsArr,
        'click-search': clickSearch

    };
    $.ajax({
        url: ajaxUrl,
        data: data,
        type: 'POST',
        success: function (results) {
            if (results) {
                galleryLoadMore.removeClass('is-loading loading-start').removeAttr('disabled');
                let res = JSON.parse(results);
                $('.gallery-posts-js').append(res.posts);
                currentPage++;
                galleryLoadMore.data('current-page', currentPage);
                galleryLoadMore.data('post-ids-arr', res.post_ids_arr);

                if (currentPage == res.pages) $('#gallery_load_more').hide('fast');

                setTimeout(function () {
                    $('#blog-articles').find('.card-animation').removeClass('card-animation');
                }, 1);
            } else {
                $('#gallery_load_more').hide('fast');
            }
        }
    });
});


// Hide block if it is empty
document.addEventListener("DOMContentLoaded", function () {
  const contentBlock = document.querySelector(".content-intro");
  if (!contentBlock) return;

  const paragraph = contentBlock.querySelector("p");
  if (!paragraph || paragraph.textContent.trim() === "") {
    contentBlock.classList.remove("show");
    contentBlock.classList.add("hide");
  } else {
    contentBlock.classList.remove("hide");
    contentBlock.classList.add("show");
  }
});
